import React from "react";
import { Box, Typography } from "@mui/material";
import celebration from "../../../assets/images/celebration2.svg";

interface SendWishesHeaderProps {
  title: string;
  isLoading: boolean;
  onSendWishes: () => void;
  selectAllChecked: boolean;
  setSelectAllChecked: (checked: boolean) => void;
  onSelectAllChange: (checked: boolean) => void;
}

const SendWishesHeader: React.FC<SendWishesHeaderProps> = ({
  title,
  isLoading,
  onSendWishes,
  // selectAllChecked,
  // setSelectAllChecked,
  // onSelectAllChange,
}) => {
  // const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   const checked = e.target.checked;
  //   setSelectAllChecked(checked);
  //   onSelectAllChange(checked);
  // };

  return (
    <Box p={1}>
      <Box
        sx={{
          padding: "10px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          borderRadius: "5px",
          backgroundColor: "#393939",
        }}
      >
        <Typography
          sx={{
            fontSize: "12px",
            display: "flex",
            alignItems: "center",
          }}
        >
          <img
            src={celebration}
            alt="logo"
            style={{ paddingRight: "7px", width: "16px", height: "16px" }}
          />
          {title}
        </Typography>
        <Typography
          sx={{
            cursor: !isLoading ? "pointer" : "not-allowed",
            color: !isLoading ? "#ffffff" : "#888888",
            opacity: !isLoading ? 1 : 0.6,
            fontSize: "11px",
            fontWeight: "600",
          }}
          onClick={() => {
            if (!isLoading) {
              onSendWishes();
            }
          }}
        >
          SEND WISHES
        </Typography>
      </Box>

      {/* <FormControlLabel
        control={
          <Checkbox
            checked={selectAllChecked}
            onChange={handleCheckboxChange}
            sx={{
              paddingLeft: "0px",
              color: "#ffffff",
              borderColor: "#ffffff",
              "&.Mui-checked": {
                color: "#EF2E24!important",
                borderColor: "#EF2E24",
              },
            }}
          />
        }
        label="Select All"
        sx={{
          mt: 1,

          mx: 1,
          "& .MuiTypography-root": {
            fontSize: "14px",
            cursor: "pointer",
          },
        }}
      /> */}
    </Box>
  );
};

export default SendWishesHeader;
